module.exports = __webpack_public_path__ + "img/9.72d9a5a1.jpg";